import React from "react";

interface FormFooterButtons extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const FormFooterButtons = React.forwardRef<HTMLDivElement, FormFooterButtons>(
    ({ children, className, ...props }, ref) => {
        return (
            <div className={`userful-form-footer-buttons ${className || ""}`} ref={ref} {...props}>
                {children}
            </div>
        );
    },
);

FormFooterButtons.displayName = "FormFooterButtons";

export default FormFooterButtons;
